exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#header .top-menu-area .promotions[data-v-08cf0bbc]{text-align:center}#header .top-menu-area .promotions a[data-v-08cf0bbc]{color:#cc242a;color:var(--secondary-lighter);text-transform:uppercase;font-size:1.2em}#header .top-menu-area .promotions a[data-v-08cf0bbc]:hover,#header .top-menu-area .promotions a[data-v-08cf0bbc]:visited{color:#cc242a;color:var(--secondary-lighter)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-08cf0bbc","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ixcms/themes/heartlandtan/src/vue-src/top-level/account-nav.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"optionsId":"0","vue":true,"id":"data-v-08cf0bbc","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ixcms/themes/heartlandtan/src/vue-src/top-level/account-nav.vue
// module chunks = 24